/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 同步票夹的所有数据到新的票夹
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: boolean;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/order/ticket-folder/data-sync`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
